/**
 * Parte inferior del sidebar contiene avatar y nombre del usuario
 */
import React, { useRef } from "react";
import { useUsuario } from '../../context/usuarioContext';
import { Avatar } from 'primereact/avatar';
import { OverlayPanel } from "primereact/overlaypanel";

const SidebarUser = ({ image }) => {
  const { usuario, cargando, logout, cambiarContrasena } = useUsuario();
  const op = useRef(null);

  if (cargando || !usuario) { return 'Cargando...'; }

  const toggleMenu = (e) => { op.current.toggle(e); };

  return (
    <div className="sidebar-footer">
      <div className="mt-3 relative">
        {/* Boton avatar con opciones desplegables */}
        {usuario && (
          <button 
            onClick={toggleMenu} 
            type="button" 
            className="flex align-items-center cursor-pointer pl-3 gap-2 border-round text-700 hover:surface-100 transition-duration-150 transition-colors bg-transparent border-none w-full text-left"
          >
            <Avatar 
              icon="pi pi-user"
              size="large"
              shape="circle"
              style={{ backgroundColor: '#e83b3b', color: '#ffffff' }}
            />
            <span className="font-bold">
              {usuario.nombre} {usuario.apellido_paterno} {usuario.apellido_materno}
            </span>

          </button>
        )}

        {/* OverlayPanel con opciones de usuario */}
        <OverlayPanel ref={op} dismissable className="overlay-panel-user">
          <ul className="list-none m-0 p-0">
            <li>
              <div className="container-user-option">
                <i className="pi pi-asterisk" style={{ fontSize: '1rem' }}></i>
                <button  className="btn-opt-user" onClick={cambiarContrasena} >
                  Cambiar Contraseña
                </button>
              </div>
            </li>

            {/* <li>
              <div className="container-user-option">
                <i className="pi pi-user" style={{ fontSize: '1rem' }}></i>
                <button 
                  className="btn-opt-user"
                  onClick={() => alert("Ver perfil")}>
                  Ver perfil
                </button>
              </div>
            </li> */}

            {/* <hr className="m-1"></hr> */}

            <li>
              <div className="container-user-option">
                <i className="pi pi-sign-out" style={{ fontSize: '1rem' }}></i>
                <button
                  className="btn-opt-user"
                  onClick={logout}>
                  Cerrar sesión
                </button>
              </div>
            </li>
          </ul>
        </OverlayPanel>
      </div> 
    </div>
  );
};

export default SidebarUser;
